module.exports = __webpack_public_path__ + "media/B25.ce7f819d.mp3";